import { useCallback, useEffect, useState } from "react";
import { faLink, faUnlink } from "@fortawesome/free-solid-svg-icons";
import { $getSelection, $isRangeSelection } from "lexical";
import { $isLinkNode, TOGGLE_LINK_COMMAND } from '@lexical/link';
import { $findMatchingParent } from '@lexical/utils';
import ToolbarButton from "../../../components/ToolbarButton";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export default function Link()
{
    const [editor] = useLexicalComposerContext();
    const [isLink, setIsLink] = useState(false);
    const [hasSelection, setHasSelection] = useState(false);

    useEffect(() =>
    {
        return editor.registerUpdateListener(({ editorState }) =>
        {
            editorState.read(() =>
            {
                const selection = $getSelection();
                if ($isRangeSelection(selection))
                {
                    const node = selection.anchor.getNode();
                    const linkParent = $findMatchingParent(node, $isLinkNode);
                    setIsLink(linkParent != null);
                    setHasSelection(!selection.isCollapsed());
                }
                else
                {
                    setIsLink(false);
                    setHasSelection(false);
                }
            });
        });
    }, [editor]);

    const handleClick = useCallback(() =>
    {
        if (isLink)
        {
            editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
        }
        else
        {
            const url = window.prompt('Enter URL:', 'https://');
            if (url)
            {
                editor.dispatchCommand(TOGGLE_LINK_COMMAND, url);
            }
        }
    }, [editor, isLink]);

    const title = isLink ? 'Remove Link' : 'Insert Link';
    const icon = isLink ? faUnlink : faLink;
    const enabled = hasSelection || isLink;
    const element =
    <ToolbarButton
        title={title}
        icon={icon}
        selected={isLink}
        enabled={enabled}
        onClick={handleClick}
    />;
    return element;
}
